import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import useFetchCauses from '../../hooks/fetchCauses';
import { Form, Input, Row, Col, Select, DatePicker, Pagination } from 'antd';
import { app } from '../../config';
import { CSVLink } from 'react-csv';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { dateConverter } from '../../utils/utcDateConversion';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';

const Usersreport = () => {
  const donorId = JSON.parse(localStorage.getItem('donorId'));
  const user = JSON.parse(localStorage.getItem('user'));
  const org =localStorage.getItem('org');
  // const orgId=org?Number(org):null;
  let organizationId = org?Number(org):null;
  console.log(org)
 
const {t}=useTranslation(["common"])
let {Search} = Input;
let navigate=useNavigate();
let users;
let searchedUser;
const token=getTokenfromUserObj()
function goBack() {
  if(user.userType==="A")navigate('/donor/view',{replace:true});
  else if(user.userType==="O")navigate('/orgreport/donors',{replace:true});
}
window.addEventListener('popstate', goBack);
const [form] = Form.useForm();
const [getLIst,setGetList ] = useState(false);
const [reportObj, setReportObj] = useState({});
const [search,setSearch]=useState('');
const [current, setCurrent] = useState(1);
const [fetchUsers,setFetchUsers] = useState([]);
const [pagesCount, setPagesCount] = useState(0);
const [searchShow,setSearchShow]=useState(false);
const [renderList,setRenderList]=useState();
const [tableShow,setTableShow]=useState(true);
const [isOrg,setisOrg]=useState(false);
  const [orgId, setOrgId] = useState(); 
  const [userType, setuserType] = useState();
const [donorObj,setDonorObj]=useState({});
const [show, setShow] = useState(false);
const [err,setErr]=useState('');
const cause =localStorage.getItem('causeId');
let cId=cause?Number(cause):null;
let causeId=cause?Number(cause):null;
console.log(causeId);  
useEffect(()=>{
  if(localStorage.getItem('org'))setisOrg(true)
  if(!localStorage.getItem('org'))setisOrg(false)
  },[]) 
  // useEffect(()=>{
  //   if(localStorage.getItem('org'))setisOrg(true)
  //   if(!localStorage.getItem('org'))setisOrg(false)
  //   },[])    
let causeResp;
// if(orgId)setisOrg(true);
if(user.userType==="O")causeResp=getCauseByOrg(user.organizationId)
else if(user.userType==="A")causeResp=useFetchCauses();
console.log(causeResp);
let causeObj=causeResp.response?causeResp.response.data:[];
let orgResp;
let orgObj;
if(user.userType==="A"){
orgResp=useFetchOrganizations();
console.log(orgResp); orgObj=orgResp.response?orgResp.response.data:[];
console.log(orgObj)
console.log(window.location.pathname)
}
let newStartDate;
let newEndDate;
  const fetchInitialData=async()=>{
    console.log("fetchInitialData Running");
    let obj={
      limit:1000,
      offset:0,
     }
     let searchQuery;
     if(user.userType==='A')searchQuery =`${app.URL}/user/getuserspage`
     else if(user.userType==='O')searchQuery =`${app.URL}/user/getorguserspage/${user.organizationId}`
     const userResp=await axios.post(searchQuery,obj,{headers:{auth:token}});
     console.log("Transaction Resp");
     console.log(userResp);
     let dateConv;
    //  userResp.data?localStorage.removeItem("causeId"):" ";
    //  userResp.data? dateConv=dateConverter(userResp.data.data,"donationDate"):" ";
     userResp.data?setCurrent(1):0;
     userResp.data?setFetchUsers(userResp.data.data):console.log(0);
     userResp.data?setRenderList(userResp.data.data.slice(0,50))||setPagesCount(userResp.data.data.length):[]
     setGetList(false)
  }
useEffect(()=>{
// if(orgId){
  let obj={
    limit:1000,
    offset:0
   }
 fetchInitialData()
// }
},[]) 

  const fetchOrgUsers = async (userType)=>{
  console.log("get Org Data Running");
  let obj={
    limit:1000,
    offset:0
   }
    let searchQuery;
    let type = userType ? `?userType=${userType}` : ''
    let org = orgId ? orgId : '';
   if(user.userType==='A')searchQuery =`${app.URL}/user/getorguserspage/${org}${type}`
   const userResp=await axios.post(searchQuery,obj,{headers:{auth:token}});
   console.log(userResp);
   let dateConv;
  //  transResp.data? dateConv=dateConverter(transResp.data.data,"donationDate"):" ";
   userResp.data?setCurrent(1):0;
   userResp.data?setFetchUsers(userResp.data.data):console.log(0);
   userResp.data?setRenderList(userResp.data.data.slice(0,50))||setPagesCount(userResp.data.data.length):[]
   setGetList(false)
}
useEffect(()=>{
// if(orgId){
let obj={
  limit:1000,
  offset:0
 }
 fetchOrgUsers()
// }
},[orgId]) 


const fetchData=async (obj)=>{
  console.log("fetchData")
  const limit=1000;
  const offset=0;
  obj.limit=limit;
  obj.offset=offset;
  obj.organizationId=user.userType==="A"?obj.organizationId:user.organizationId;
  obj.startDate=reportObj.startDate;
  obj.endDate=reportObj.endDate;
  console.log(obj);
 
  let searchQuery;
  if(window.location.pathname==='/orgreport/donation'&&user.userType==='O')searchQuery =`${app.URL}/trans/searchtransbyorg/${user.organizationId}`
  if(window.location.pathname==='/reports/donation'&&user.userType==='A')searchQuery =`${app.URL}/trans/searchtrans`
  if(window.location.pathname==='/donor/donationhistory'&&user.userType==='A')searchQuery =`${app.URL}/trans/viewbydonor/${donorId}`
  if(window.location.pathname==='/orgdonor/donationhistory'&&user.userType==='O')searchQuery =`${app.URL}/trans/viewbydonorandorg/${donorId}/${user.organizationId}`
  console.log(searchQuery)
  console.log(obj)  
  const transResp=await axios.post(searchQuery,obj,{headers:{auth:token}});
  console.log(transResp);
  let dateConv;

  transResp.data? dateConv=dateConverter(transResp.data.data,"donationDate"):" ";
  transResp.data?setCurrent(1):0;
  transResp.data?setFetchUsers(dateConv):console.log(0);
  transResp.data?setRenderList(dateConv.slice(0,50))||setPagesCount(transResp.data.data.length):[]
  setGetList(false)

}
let amount=0;
fetchUsers?fetchUsers.map((ele)=>{
  if(ele.status === 'Approved'){
  return amount+=Number(ele.amount)
  }
}):" ";
amount=amount.toFixed(2)
console.log("amount "+amount);
const onFinish = (values) => {
  console.log('Success:', values);
  setReportObj({
    organizationId:values.organizationId?values.organizationId:null,
    userType:values.userType?values.userType:null
  })
  if (values.organizationId) setOrgId(values.organizationId)
  // if (values.userType) setuserType(values.userType)
  fetchOrgUsers(values.userType)
};
const onFinishFailed = (errorInfo) => {
  console.log('Failed:', errorInfo);
};
console.log(reportObj)
const handleClearClick = () => {
  causeId=null;
  form.resetFields();
  fetchInitialData();
  setOrgId("");
  setGetList(true)
};
useEffect(()=>{
  if(Object.keys(reportObj).length>0)fetchData(reportObj);
},[reportObj]);
useEffect(() => {
  const userList=async()=>{
    console.log("user list function called")
    const limit=1000;
    const offset=0;
    let convertedObj;
    let fetchQuery;
    
    if(user.userType==='O'&&window.location.pathname==='/orgreport/donation')fetchQuery =`${app.URL}/trans/viewbyorg/${user.organizationId}`
    if(user.userType==='A'&&window.location.pathname==='/reports/donation')fetchQuery =`${app.URL}/trans/view`
    if(user.userType==='A'&&window.location.pathname==='/donor/donationhistory')fetchQuery =`${app.URL}/trans/viewbydonor/${donorId}`
    if(user.userType==='O'&&window.location.pathname==='/orgdonor/donationhistory')fetchQuery =`${app.URL}/trans/viewbydonorandorg/${donorId}/${user.organizationId}`
    console.log(fetchQuery);
    const userResp=await axios.post(fetchQuery,{limit,offset},{headers:{auth:token}});
    console.log("🚀 ~ file: Users.js:31 ~ userList ~ userResp", userResp.data)
    userResp.data?convertedObj=dateConverter(userResp.data.data,"donationDate"):" ";  
    userResp.data?setFetchUsers(convertedObj):" ";
    userResp.data?setPagesCount(convertedObj.length):" ";
    userResp.data?setRenderList((convertedObj).slice(0,50)):" ";
   
  }
if(!localStorage.getItem("org")&&!localStorage.getItem("causeId")){
  userList();
}
  }, []);
const handleSearch=async()=>{
  console.log("calling");
    try{
        const result=search?await axios.get(`${app.URL}/user/search/${search}`):[];
        console.log(result);
        searchedUser=result.data.data;
       }
       catch(e){
         console.log("Error");
       if(e.message)setErr(e.response.data.message);
       setTableShow(false);
       }
       
       console.log(searchedUser)
       if(searchedUser){
         setSearchShow(true);
         setRenderList(searchedUser)
       }
       console.log(searchedUser);
}
const onSearch = async (value) => {
  console.log(value);
  try{
    const result=await axios.get(`${app.URL}/user/search/${value}`);
    console.log(result);
     searchedUser=result.data.data;
     setRenderList(searchedUser);
     setPagesCount(searchedUser.length);
   }
   catch(e){
     console.log("Error");
   if(e.message)setErr(e.response.data.message);
   setTableShow(false);
   }
}
const onChange = async(page,pageSize) => {
  console.log(page);
  setCurrent(page);
  if(!page)page=1;
  let limit=pageSize;
  let reqObj={
    limit,
    offset:limit*(page-1)
  }
  setRenderList(fetchUsers.slice(reqObj.offset, reqObj.offset + limit));
  // if(users){
  //   console.log("users")
  //   setRenderList(users)
  // }
  console.log(renderList);
};

const handleSearchChange=(e)=>{
  console.log(e.target.value);
  if(!e.target.value){
   setRenderList(fetchUsers.slice(0,50));
   setPagesCount(fetchUsers.length);
   setTableShow(true);};
  setSearch(e.target.value)
} 

const editUser=(e)=>{
    console.log(e);
    localStorage.setItem("getUserId",JSON.stringify(e.userId));
    navigate('/user/edit',{replace:true});
}
const addUser=()=>{
  navigate('/user/add',{replace:true});
}
console.log(renderList);
const handleClose = () => setShow(false);

const userInfo=async(donorId)=>{
  console.log(donorId)
  let fetchApi=`${app.URL}/user/getuserdonor/${donorId}`
  const donorResp=await axios.get(fetchApi,{headers:{auth:token}});
  console.log(donorResp.data.data)
  const donorObj=donorResp.data?donorResp.data.data:{};
  setDonorObj(donorObj)
  setShow(true);
}
  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
        <div className='row mt-2'>
        <div className="col-lg-12 col-md-10 col-sm-10 fs-3 fw-bold">
        {t('User Report')}
        </div>
        <div className='row mt-3 ml-1'>
        <Form
        name='basic'
        form={form}
        className='ml-5'
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 8,
        }}
        style={{ alignItems: 'flexEnd' }}
        // style={{
        //   maxWidth: 600,
        // }}
        initialValues={{
          remember: true,
          // ['organizationId']: organizationId?organizationId:null,
          // ['causeId']: causeId?causeId:null,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
      >
       <Row gutter={[16, 16]}>
      {user.userType==="A"? <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={5}>
         <Form.Item
        //  style={{width:"700px"}}
              colon={false}
              name='organizationId'
              rules={[
                {
                  required: false ,
                  message:"Select Organization",
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                style={{
                  // width: 160,
                }}
                placeholder="Select Organization"
              >
                { orgObj.map((orgs) => {
                  return (
                    <Option key={orgs.organizationId} value={orgs.organizationId} >
                      {orgs.organizationName}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
         </Col>   :" "} 
        <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={5}>
         <Form.Item
        //  style={{width:"700px"}}
              colon={false}
              name='userType'
              rules={[
                {
                  required: false ,
                  message:"Select user type",
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                style={{
                  // width: 160,
                }}
                placeholder="Select user type"
              >
                    <Option key="0" value="A" >
                      Admin
                    </Option>
                    <Option key="1" value="O" >
                      Organization User
                    </Option>
                  
              
              </Select>
            </Form.Item>
         </Col> 
      
        
        
         <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={2}>
         <Form.Item
          colon={false}
          
         >
         <button className='btn btn-primary button' onClick={handleClearClick}>Clear</button>
         </Form.Item>
         </Col>
         
         <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={3}>
         <Form.Item
          colon={false}
          
         >
          <button type='primary' class='btn btn-primary button' htmlType='submit'>Search</button>
         </Form.Item>
         </Col>
         <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={3}>
         <CSVLink className='excel-btn'  icon={faFileExcel} filename={"donation-report.csv"} data={fetchUsers}><img style={{marginTop:"-5px"}} src="/excel.png"/></CSVLink>
         {/* <Button><CSVLink  filename={"donation-report.csv"} data={respList}>Export</CSVLink></Button>  */}
         </Col>
       </Row>
       
        </Form>
        {/* <div><b>Total Donations:</b>$ {amount}</div>         */}
        </div>
        {/* <div className="col-lg-2 col-md-2 col-sm-2">
        <button class="btn btn-primary button" onClick={addUser}>Add</button>  
        </div>   */}
        </div>
      <div className='col-lg-11 col-md-12 col-sm-12 '>
      <div class=' styled-table '>
         <table class='table text-black' >
           <thead class='thead-light'>
             <tr>
             {/* <th>{t("ID")}</th> */}
             <th>{t('Organization Name')}</th>
             <th>{t('Name')}</th>
                      <th>{t('Email')}</th>
                      <th>{t('Phone')}</th>
                       <th>{t('User Type')}</th>
                       <th>{t('Status')}</th>
                       <th> </th>
             </tr>
           </thead>
           <tbody >

           {renderList
                       ? renderList.map((output) => (
                           <tr className='row-hover'>
                             {/* <td>{output.name}</td> */}
                             <td>{output.organizationName?output.organizationName:"Admin (Donation4all)"}</td>
                             <td>{output.usertype === 'A' ? output.name : output.userType === 'D' ? output.donorName : output.name}</td>
                             <td>{output.email}</td>
                             <td>{output.phone}</td>
                             <td>{output.userType === 'D' ? 'Donor' : output.userType === 'A' ? 'Admin' : output.userType === 'O' ? 'Organization User' : ' '}</td>
                             <td>{output.isActive=="1"?"Active":"Inactive"}</td>
                             {/* <td><button type="button" class="btn btn-primary color1 button" onClick={() => editUser(output)}>{t("Edit")}</button></td> */}
                             <td></td>
                           </tr>
                         ))
                       : ' '}
           </tbody>
         </table>
         {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
       </div>
       {/* <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-center'>Success</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>  <form>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row '>
        <div className='col-lg-4 mt-1'>Name </div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={`${donorObj.firstName} ${donorObj.lastName}`} /></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row '>
        <div className='col-lg-4 mt-1'>Email </div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={`${donorObj.email}`} /></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row '>
        <div className='col-lg-4 mt-1'>Mobile </div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={`${donorObj.phone}`} /></div>
      </div>
    </div>
    </fieldset>
    </form></Modal.Body>
                  <Modal.Footer><Button onClick={()=>{setShow(false)}}>Close</Button></Modal.Footer>
                </Modal> */}
      </div>
      <Pagination style={{marginTop:"10px"}} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
      </div>

  );
};

export default Usersreport;
